module.exports = __webpack_public_path__ + "static/VLogo-c2434463c44831407adeb0547215be65.png";